module.exports = __webpack_public_path__ + "img/055-scotland.ebae9594.svg";